/**
 * Normalize a user-entered domain for snapshot + project flows.
 */
export function normalizeDomainInput(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  let host = trimmed.replace(/^https?:\/\//i, "").split("/")[0] ?? "";
  host = host.split(":")[0] ?? "";
  host = host
    .replace(/^www\./i, "")
    .toLowerCase()
    .replace(/\.+$/, "");
  if (!host) return null;

  if (
    !/^[a-z0-9.-]+$/.test(host) ||
    host.includes("..") ||
    host.startsWith(".")
  ) {
    return null;
  }
  if (!host.includes(".")) {
    return null;
  }
  const labels = host.split(".");
  const tld = labels[labels.length - 1];
  if (tld.length < 2) return null;

  return host;
}

export function isValidEmailFormat(email: string): boolean {
  const e = email.trim();
  if (e.length > 254) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}

export function emailDomain(email: string): string {
  return email.trim().split("@")[1]?.toLowerCase() ?? "";
}

const PERSONAL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "icloud.com",
  "me.com",
  "msn.com",
  "aol.com",
  "protonmail.com",
  "pm.me",
]);

export function isLikelyWorkEmail(email: string): boolean {
  const d = emailDomain(email);
  return d.length > 0 && !PERSONAL_DOMAINS.has(d);
}
